
const module2 = [];


export default module2



// WEBPACK FOOTER //
// ./src/router/module/module2.js